<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <!-- 구매요청됨 탭에서만 요청 생성 버튼 표시 -->
      <button
        *ngIf="currentTabStatus === 'Requested'"
        class="button primary"
        (click)="createRequest()"
        style="margin-right: 1rem"
      >
        {{ "requestPurchase.create-request" | translate }}
      </button>
      <!-- 구매요청됨 탭: 구매 완료 처리 버튼 -->
      <div *ngIf="currentTabStatus === 'Requested'">
        <button
          class="button primary"
          (click)="approve()"
          *vdrIfPermissions="['ApprovePurchaseRequest', 'ReadPurchaseRequest']"
          style="margin-right: 1rem"
          [disabled]="selectionManager.selection.length <= 0 || isLoading"
        >
          {{ "requestPurchase.complete-purchase" | translate }}
        </button>
      </div>
      
      <!-- 구매승인요청중 탭: 승인/거절 버튼 -->
      <div *ngIf="currentTabStatus === 'PendingApproval'">
        <button
          class="button primary"
          (click)="finalApprove()"
          *vdrIfPermissions="['ApprovePurchaseRequest', 'ReadPurchaseRequest']"
          style="margin-right: 1rem"
          [disabled]="selectionManager.selection.length <= 0 || isLoading"
        >
          {{ "requestPurchase.approve" | translate }}
        </button>
        <button
          class="button danger"
          (click)="reject()"
          *vdrIfPermissions="['ApprovePurchaseRequest', 'ReadPurchaseRequest']"
          [disabled]="selectionManager.selection.length <= 0 || isLoading"
        >
          {{ "requestPurchase.reject" | translate }}
        </button>
      </div>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  id="request-purchase-table"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="request-purchase-table"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <!-- <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'Search by code'"
  ></vdr-dt2-search> -->
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="true"
  >
    <ng-template let-purchasedNeededGroup="item">
      {{ purchasedNeededGroup.id }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.identifier' | translate"
    id="id"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      {{ purchasedNeededGroup.identifier ?? "*" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.productName' | translate"
    id="code"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      <a
        class="button-ghost"
        [routerLink]="['/catalog/products/', purchasedNeededGroup.product.id]"
        ><span> {{ purchasedNeededGroup.product.name }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.variant-or-free-gifts' | translate"
    id="name"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      <div class="requests-column grid-space-variant">
        <ng-container *ngFor="let request of purchasedNeededGroup.requests">
          <div *ngIf="!request.productId; else freeGift" class="request-block">
            <a
              class="button-ghost"
              style="display: flex; justify-content: start; width: fit-content"
              [routerLink]="[
                '/catalog/products/',
                purchasedNeededGroup.productId,
                'variants',
                request.productVariantId
              ]"
              ><span> {{ request.productVariant.name }}</span
              ><clr-icon shape="arrow right"
            /></a>
          </div>
          <ng-template #freeGift>
            <div class="request-block freegift-block">
              <a
                class="button-ghost"
                style="
                  display: flex;
                  justify-content: start;
                  width: fit-content;
                "
                [routerLink]="[
                  '/catalog/products/',
                  purchasedNeededGroup.productId,
                  'variants',
                  request.productVariantId
                ]"
                ><span> {{ request.productVariant.name }}</span
                ><clr-icon shape="arrow right"
              /></a>
              <div class="button-small freegift-badge">
                Free gift <clr-icon shape="shopping-bag" />
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.orderQuantity' | translate"
    id="name"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      <div class="requests-column grid-space">
        <div
          *ngFor="let request of purchasedNeededGroup.requests"
          class="request-block center-block"
        >
          <div style="align-self: center">
            {{ request.orderQuantity }}
          </div>
        </div>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.currentStock' | translate"
    id="note"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      <div class="requests-column grid-space">
        <div
          *ngFor="let request of purchasedNeededGroup.requests"
          class="request-block center-block"
        >
          <div style="align-self: center">
            {{ request.stockOnHand }}
          </div>
        </div>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.quantityNeeded' | translate"
    id="note"
    [hiddenByDefault]="false"
    style="padding-left: 0; padding-right: 0"
  >
    <ng-template let-purchasedNeededGroup="item">
      <div class="requests-column grid-space">
        <div
          *ngFor="let request of purchasedNeededGroup.requests"
          class="request-block center-block"
        >
          <div style="align-self: center">
            {{
              (request.notSpecify
                ? "requestPurchase.not-specify-stock"
                : request.quantityNeeded
              ) | translate
            }}
          </div>
        </div>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.supplier' | translate"
    id="note"
    [hiddenByDefault]="false"
    style="padding-left: 0; padding-right: 0"
  >
    <ng-template let-purchasedNeededGroup="item">
      {{ purchasedNeededGroup.shopSupplier?.name }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.retailer' | translate"
    id="note"
    [hiddenByDefault]="false"
    style="padding-left: 0; padding-right: 0"
  >
    <ng-template let-purchasedNeededGroup="item">
      {{ purchasedNeededGroup.retailer?.name }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.status' | translate"
    id="note"
    [hiddenByDefault]="false"
    style="padding-left: 0; padding-right: 0"
  >
    <ng-template let-purchasedNeededGroup="item">
      <div>
        {{ status(purchasedNeededGroup.status) }}
      </div>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'requestPurchase.createdAt' | translate"
    id="note"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      {{ purchasedNeededGroup.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'requestPurchase.detail' | translate"
    id="detail"
    [hiddenByDefault]="false"
  >
    <ng-template let-purchasedNeededGroup="item">
      <a class="button-ghost" [routerLink]="['/extensions/purchase-request', purchasedNeededGroup.id]"
        ><span> {{ "requestPurchase.detail" | translate }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
